module.exports = __webpack_public_path__ + "static/media/medal.196767b6.png";